module.exports = __webpack_public_path__ + "img/xiao-mei.5f50c5de.png";